/**
 * Cursos (tag "curso"): cantidad fija 1 en carrito y una sola unidad por variante.
 */
(function () {
  var clamping = false;

  function isCursoForm(form) {
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return false;
    var wrapper = form.closest('product-form-component');
    return wrapper && wrapper.getAttribute('data-es-curso') === 'true';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isCursoForm(form)) return;

      var qty = form.querySelector('[name="quantity"]');
      if (qty) {
        qty.value = '1';
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    async function (event) {
      var form = event.target;
      if (!isCursoForm(form)) return;

      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) return;

      try {
        var response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        var cart = await response.json();
        var variantId = String(variantInput.value);
        var existing = cart.items.find(function (item) {
          return String(item.variant_id) === variantId;
        });

        if (existing && existing.quantity >= 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.alert('Este curso ya está en tu carrito. Solo puedes comprar una unidad.');
        }
      } catch (error) {
        console.warn('ESC curso cart check failed', error);
      }
    },
    true
  );

  async function clampCursoLineQuantities() {
    if (clamping) return;

    var cursoRows = document.querySelectorAll('.cart-items__table-row[data-es-curso="true"]');
    if (!cursoRows.length) return;

    try {
      var response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      var cart = await response.json();
      var needsUpdate = false;

      clamping = true;

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var row = document.querySelector(
          '.cart-items__table-row[data-es-curso="true"][data-key="' + CSS.escape(item.key) + '"]'
        );
        if (row && item.quantity > 1) {
          needsUpdate = true;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ line: item.index + 1, quantity: 1 }),
          });
        }
      }

      clamping = false;

      if (needsUpdate) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      }
    } catch (error) {
      clamping = false;
      console.warn('ESC curso quantity clamp failed', error);
    }
  }

  document.addEventListener('cart:update', function () {
    window.setTimeout(clampCursoLineQuantities, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clampCursoLineQuantities);
  } else {
    clampCursoLineQuantities();
  }
})();
